import { PaymentMethod } from 'types';
import { Reducer } from 'redux';
import { RootReducerType } from './index';
import {
  FETCH_PAYMENTS_REQUEST,
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_FAILURE,
  PAYMENT_METHODS_UPDATE,
  PAYMENT_METHODS_FAILURE_UPDATE,
  PAYMENT_METHODS_DELETE,
  PAYMENT_METHODS_ADD,
  PAYMENT_METHODS_MAKE_DEFAULT,
  PAYMENT_METHODS_RESET,
  PAYMENT_METHODS_RESET_ERROR,
  PAYMENT_METHODS_ADDED_TO_WALKIN_REQUEST
} from 'store/types/paymentMethods';
import { Actions } from 'store/actions/paymentMethods';

export type State = {
  paymentMethods: PaymentMethod[];
  defaultPayment: string | null;
  isFetching: boolean;
  isUpdating: boolean;
  error: string;
};

const initialState = {
  paymentMethods: [],
  defaultPayment: localStorage.getItem('defaultPayment'),
  isFetching: false,
  isUpdating: false,
  error: '',
};

export const paymentsReducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENTS_REQUEST:
      return { ...state, isFetching: true };
    case FETCH_PAYMENTS_SUCCESS:
      return { ...state, paymentMethods: action.preload, isFetching: false };
    case FETCH_PAYMENTS_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case PAYMENT_METHODS_UPDATE:
      return { ...state, isUpdating: true, error: '' };
    case PAYMENT_METHODS_FAILURE_UPDATE:
      return { ...state, isUpdating: false, error: action.error };

    case PAYMENT_METHODS_DELETE:
      return {
        ...state,
        paymentMethods: state.paymentMethods.filter(item => item.card_id !== action.id),
        isUpdating: false,
      };
    case PAYMENT_METHODS_ADD:
      return { ...state, isUpdating: false };
    case PAYMENT_METHODS_MAKE_DEFAULT: {
      let itemIndex = state.paymentMethods.findIndex((item: PaymentMethod) => item.card_id === action.cardId)
      if (itemIndex > -1) {
        if (action.defaultCard) return { ...state, isUpdating: false, paymentMethods: [...state.paymentMethods.slice(0, itemIndex).map((item: PaymentMethod) => ({ ...item as PaymentMethod, is_default: false })), { ...state.paymentMethods[itemIndex] as PaymentMethod, is_default: true }, ...state.paymentMethods.slice(itemIndex + 1).map((item: PaymentMethod) => ({ ...item as PaymentMethod, is_default: false }))] }
        else return { ...state, isUpdating: false, paymentMethods: [...state.paymentMethods.slice(0, itemIndex), { ...state.paymentMethods[itemIndex] as PaymentMethod, is_default: false }, ...state.paymentMethods.slice(itemIndex + 1)] }
      }
      else return state;
    }

    case PAYMENT_METHODS_RESET_ERROR:
      return { ...state, error: '' }
    case PAYMENT_METHODS_RESET:
      return initialState
      case PAYMENT_METHODS_ADDED_TO_WALKIN_REQUEST:
        return { ...state, isUpdating: false };
    default:
      return state;
  }
};

export default paymentsReducer;
export const paymentsSelector = (state: RootReducerType) => state.paymentMethods;
